export default __webpack_public_path__ + "static/media/tip3a.1e0920cf.png";